/**
 * Generated by orval v8.0.0-rc.2 🍺
 * Do not edit manually.
 * SEMO API
 * ## SEMO MVP REST API

한국 서비스 마켓플레이스 백엔드 API 문서. 인증, 채팅, 견적, 계약, 결제를 포함합니다.

**버전**: `v1.0.0`
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  ChatControllerGetMessages200,
  ChatControllerGetMessagesParams,
  ChatControllerGetRoom200,
  ChatControllerGetRooms200,
  ChatControllerGetRoomsParams,
  ChatControllerRequestContractDocuments200,
  ChatControllerSendMessage200,
  ChatControllerSubmitContractDocumentBuyerConfirmation200,
  ChatControllerSubmitContractDocumentInput200,
  ChatControllerSubmitQuoteRevision200,
  ChatControllerUploadContractDocumentFile200,
  ChatControllerUploadContractDocumentFileBody,
  ChatControllerUploadFile200,
  ChatControllerUploadFileBody,
  CreateMessageDto,
  CreateQuoteResponseVersionDto,
  MarkRoomAsReadDto,
  RequestContractDocumentsDto,
  SubmitContractDocumentBuyerConfirmationDto,
  SubmitContractDocumentInputDto,
} from "../client.schemas";

import { api } from "../../lib/orval-mutator";
import type { ErrorType, BodyType } from "../../lib/orval-mutator";

/**
 * @summary 채팅방 목록 조회
 */
export const chatControllerGetRooms = (
  params?: ChatControllerGetRoomsParams,
  signal?: AbortSignal,
) => {
  return api<ChatControllerGetRooms200>({
    url: `/chat/rooms`,
    method: "GET",
    params,
    signal,
  });
};

export const getChatControllerGetRoomsQueryKey = (
  params?: ChatControllerGetRoomsParams,
) => {
  return [`/chat/rooms`, ...(params ? [params] : [])] as const;
};

export const getChatControllerGetRoomsQueryOptions = <
  TData = Awaited<ReturnType<typeof chatControllerGetRooms>>,
  TError = ErrorType<unknown>,
>(
  params?: ChatControllerGetRoomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof chatControllerGetRooms>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getChatControllerGetRoomsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof chatControllerGetRooms>>
  > = ({ signal }) => chatControllerGetRooms(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof chatControllerGetRooms>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ChatControllerGetRoomsQueryResult = NonNullable<
  Awaited<ReturnType<typeof chatControllerGetRooms>>
>;
export type ChatControllerGetRoomsQueryError = ErrorType<unknown>;

export function useChatControllerGetRooms<
  TData = Awaited<ReturnType<typeof chatControllerGetRooms>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ChatControllerGetRoomsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof chatControllerGetRooms>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatControllerGetRooms>>,
          TError,
          Awaited<ReturnType<typeof chatControllerGetRooms>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useChatControllerGetRooms<
  TData = Awaited<ReturnType<typeof chatControllerGetRooms>>,
  TError = ErrorType<unknown>,
>(
  params?: ChatControllerGetRoomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof chatControllerGetRooms>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatControllerGetRooms>>,
          TError,
          Awaited<ReturnType<typeof chatControllerGetRooms>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useChatControllerGetRooms<
  TData = Awaited<ReturnType<typeof chatControllerGetRooms>>,
  TError = ErrorType<unknown>,
>(
  params?: ChatControllerGetRoomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof chatControllerGetRooms>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 채팅방 목록 조회
 */

export function useChatControllerGetRooms<
  TData = Awaited<ReturnType<typeof chatControllerGetRooms>>,
  TError = ErrorType<unknown>,
>(
  params?: ChatControllerGetRoomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof chatControllerGetRooms>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getChatControllerGetRoomsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 채팅방 상세 조회
 */
export const chatControllerGetRoom = (roomId: string, signal?: AbortSignal) => {
  return api<ChatControllerGetRoom200>({
    url: `/chat/rooms/${roomId}`,
    method: "GET",
    signal,
  });
};

export const getChatControllerGetRoomQueryKey = (roomId?: string) => {
  return [`/chat/rooms/${roomId}`] as const;
};

export const getChatControllerGetRoomQueryOptions = <
  TData = Awaited<ReturnType<typeof chatControllerGetRoom>>,
  TError = ErrorType<unknown>,
>(
  roomId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof chatControllerGetRoom>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getChatControllerGetRoomQueryKey(roomId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof chatControllerGetRoom>>
  > = ({ signal }) => chatControllerGetRoom(roomId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!roomId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof chatControllerGetRoom>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ChatControllerGetRoomQueryResult = NonNullable<
  Awaited<ReturnType<typeof chatControllerGetRoom>>
>;
export type ChatControllerGetRoomQueryError = ErrorType<unknown>;

export function useChatControllerGetRoom<
  TData = Awaited<ReturnType<typeof chatControllerGetRoom>>,
  TError = ErrorType<unknown>,
>(
  roomId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof chatControllerGetRoom>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatControllerGetRoom>>,
          TError,
          Awaited<ReturnType<typeof chatControllerGetRoom>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useChatControllerGetRoom<
  TData = Awaited<ReturnType<typeof chatControllerGetRoom>>,
  TError = ErrorType<unknown>,
>(
  roomId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof chatControllerGetRoom>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatControllerGetRoom>>,
          TError,
          Awaited<ReturnType<typeof chatControllerGetRoom>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useChatControllerGetRoom<
  TData = Awaited<ReturnType<typeof chatControllerGetRoom>>,
  TError = ErrorType<unknown>,
>(
  roomId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof chatControllerGetRoom>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 채팅방 상세 조회
 */

export function useChatControllerGetRoom<
  TData = Awaited<ReturnType<typeof chatControllerGetRoom>>,
  TError = ErrorType<unknown>,
>(
  roomId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof chatControllerGetRoom>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getChatControllerGetRoomQueryOptions(roomId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 채팅 메시지 목록 조회
 */
export const chatControllerGetMessages = (
  roomId: string,
  params?: ChatControllerGetMessagesParams,
  signal?: AbortSignal,
) => {
  return api<ChatControllerGetMessages200>({
    url: `/chat/rooms/${roomId}/messages`,
    method: "GET",
    params,
    signal,
  });
};

export const getChatControllerGetMessagesQueryKey = (
  roomId?: string,
  params?: ChatControllerGetMessagesParams,
) => {
  return [
    `/chat/rooms/${roomId}/messages`,
    ...(params ? [params] : []),
  ] as const;
};

export const getChatControllerGetMessagesQueryOptions = <
  TData = Awaited<ReturnType<typeof chatControllerGetMessages>>,
  TError = ErrorType<unknown>,
>(
  roomId: string,
  params?: ChatControllerGetMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof chatControllerGetMessages>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getChatControllerGetMessagesQueryKey(roomId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof chatControllerGetMessages>>
  > = ({ signal }) => chatControllerGetMessages(roomId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!roomId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof chatControllerGetMessages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ChatControllerGetMessagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof chatControllerGetMessages>>
>;
export type ChatControllerGetMessagesQueryError = ErrorType<unknown>;

export function useChatControllerGetMessages<
  TData = Awaited<ReturnType<typeof chatControllerGetMessages>>,
  TError = ErrorType<unknown>,
>(
  roomId: string,
  params: undefined | ChatControllerGetMessagesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof chatControllerGetMessages>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatControllerGetMessages>>,
          TError,
          Awaited<ReturnType<typeof chatControllerGetMessages>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useChatControllerGetMessages<
  TData = Awaited<ReturnType<typeof chatControllerGetMessages>>,
  TError = ErrorType<unknown>,
>(
  roomId: string,
  params?: ChatControllerGetMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof chatControllerGetMessages>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatControllerGetMessages>>,
          TError,
          Awaited<ReturnType<typeof chatControllerGetMessages>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useChatControllerGetMessages<
  TData = Awaited<ReturnType<typeof chatControllerGetMessages>>,
  TError = ErrorType<unknown>,
>(
  roomId: string,
  params?: ChatControllerGetMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof chatControllerGetMessages>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 채팅 메시지 목록 조회
 */

export function useChatControllerGetMessages<
  TData = Awaited<ReturnType<typeof chatControllerGetMessages>>,
  TError = ErrorType<unknown>,
>(
  roomId: string,
  params?: ChatControllerGetMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof chatControllerGetMessages>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getChatControllerGetMessagesQueryOptions(
    roomId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 메시지 전송
 */
export const chatControllerSendMessage = (
  roomId: string,
  createMessageDto: BodyType<CreateMessageDto>,
  signal?: AbortSignal,
) => {
  return api<ChatControllerSendMessage200>({
    url: `/chat/rooms/${roomId}/messages`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createMessageDto,
    signal,
  });
};

export const getChatControllerSendMessageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof chatControllerSendMessage>>,
    TError,
    { roomId: string; data: BodyType<CreateMessageDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof chatControllerSendMessage>>,
  TError,
  { roomId: string; data: BodyType<CreateMessageDto> },
  TContext
> => {
  const mutationKey = ["chatControllerSendMessage"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof chatControllerSendMessage>>,
    { roomId: string; data: BodyType<CreateMessageDto> }
  > = (props) => {
    const { roomId, data } = props ?? {};

    return chatControllerSendMessage(roomId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChatControllerSendMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof chatControllerSendMessage>>
>;
export type ChatControllerSendMessageMutationBody = BodyType<CreateMessageDto>;
export type ChatControllerSendMessageMutationError = ErrorType<unknown>;

/**
 * @summary 메시지 전송
 */
export const useChatControllerSendMessage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof chatControllerSendMessage>>,
      TError,
      { roomId: string; data: BodyType<CreateMessageDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof chatControllerSendMessage>>,
  TError,
  { roomId: string; data: BodyType<CreateMessageDto> },
  TContext
> => {
  const mutationOptions = getChatControllerSendMessageMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 선택한 계약서류 자동 생성/제출 요청 (구매자 전용)
 */
export const chatControllerRequestContractDocuments = (
  roomId: string,
  requestContractDocumentsDto: BodyType<RequestContractDocumentsDto>,
  signal?: AbortSignal,
) => {
  return api<ChatControllerRequestContractDocuments200>({
    url: `/chat/rooms/${roomId}/contract-documents`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: requestContractDocumentsDto,
    signal,
  });
};

export const getChatControllerRequestContractDocumentsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof chatControllerRequestContractDocuments>>,
    TError,
    { roomId: string; data: BodyType<RequestContractDocumentsDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof chatControllerRequestContractDocuments>>,
  TError,
  { roomId: string; data: BodyType<RequestContractDocumentsDto> },
  TContext
> => {
  const mutationKey = ["chatControllerRequestContractDocuments"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof chatControllerRequestContractDocuments>>,
    { roomId: string; data: BodyType<RequestContractDocumentsDto> }
  > = (props) => {
    const { roomId, data } = props ?? {};

    return chatControllerRequestContractDocuments(roomId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChatControllerRequestContractDocumentsMutationResult = NonNullable<
  Awaited<ReturnType<typeof chatControllerRequestContractDocuments>>
>;
export type ChatControllerRequestContractDocumentsMutationBody =
  BodyType<RequestContractDocumentsDto>;
export type ChatControllerRequestContractDocumentsMutationError =
  ErrorType<unknown>;

/**
 * @summary 선택한 계약서류 자동 생성/제출 요청 (구매자 전용)
 */
export const useChatControllerRequestContractDocuments = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof chatControllerRequestContractDocuments>>,
      TError,
      { roomId: string; data: BodyType<RequestContractDocumentsDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof chatControllerRequestContractDocuments>>,
  TError,
  { roomId: string; data: BodyType<RequestContractDocumentsDto> },
  TContext
> => {
  const mutationOptions =
    getChatControllerRequestContractDocumentsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 계약 서류 documentInputs 제출 (공급사 전용, 135/164/188/195/222)
 */
export const chatControllerSubmitContractDocumentInput = (
  roomId: string,
  paperCode: number,
  submitContractDocumentInputDto: BodyType<SubmitContractDocumentInputDto>,
  signal?: AbortSignal,
) => {
  return api<ChatControllerSubmitContractDocumentInput200>({
    url: `/chat/rooms/${roomId}/contract-documents/${paperCode}/submit-input`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: submitContractDocumentInputDto,
    signal,
  });
};

export const getChatControllerSubmitContractDocumentInputMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof chatControllerSubmitContractDocumentInput>>,
    TError,
    {
      roomId: string;
      paperCode: number;
      data: BodyType<SubmitContractDocumentInputDto>;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof chatControllerSubmitContractDocumentInput>>,
  TError,
  {
    roomId: string;
    paperCode: number;
    data: BodyType<SubmitContractDocumentInputDto>;
  },
  TContext
> => {
  const mutationKey = ["chatControllerSubmitContractDocumentInput"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof chatControllerSubmitContractDocumentInput>>,
    {
      roomId: string;
      paperCode: number;
      data: BodyType<SubmitContractDocumentInputDto>;
    }
  > = (props) => {
    const { roomId, paperCode, data } = props ?? {};

    return chatControllerSubmitContractDocumentInput(roomId, paperCode, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChatControllerSubmitContractDocumentInputMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof chatControllerSubmitContractDocumentInput>>
  >;
export type ChatControllerSubmitContractDocumentInputMutationBody =
  BodyType<SubmitContractDocumentInputDto>;
export type ChatControllerSubmitContractDocumentInputMutationError =
  ErrorType<unknown>;

/**
 * @summary 계약 서류 documentInputs 제출 (공급사 전용, 135/164/188/195/222)
 */
export const useChatControllerSubmitContractDocumentInput = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof chatControllerSubmitContractDocumentInput>>,
      TError,
      {
        roomId: string;
        paperCode: number;
        data: BodyType<SubmitContractDocumentInputDto>;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof chatControllerSubmitContractDocumentInput>>,
  TError,
  {
    roomId: string;
    paperCode: number;
    data: BodyType<SubmitContractDocumentInputDto>;
  },
  TContext
> => {
  const mutationOptions =
    getChatControllerSubmitContractDocumentInputMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary paperCode 135(수의계약체결제한여부확인서) 발주기관 최종 확인 (구매자 전용)
 */
export const chatControllerSubmitContractDocumentBuyerConfirmation = (
  roomId: string,
  submitContractDocumentBuyerConfirmationDto: BodyType<SubmitContractDocumentBuyerConfirmationDto>,
  signal?: AbortSignal,
) => {
  return api<ChatControllerSubmitContractDocumentBuyerConfirmation200>({
    url: `/chat/rooms/${roomId}/contract-documents/135/buyer-confirmation`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: submitContractDocumentBuyerConfirmationDto,
    signal,
  });
};

export const getChatControllerSubmitContractDocumentBuyerConfirmationMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof chatControllerSubmitContractDocumentBuyerConfirmation>
      >,
      TError,
      {
        roomId: string;
        data: BodyType<SubmitContractDocumentBuyerConfirmationDto>;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof chatControllerSubmitContractDocumentBuyerConfirmation>
    >,
    TError,
    {
      roomId: string;
      data: BodyType<SubmitContractDocumentBuyerConfirmationDto>;
    },
    TContext
  > => {
    const mutationKey = [
      "chatControllerSubmitContractDocumentBuyerConfirmation",
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof chatControllerSubmitContractDocumentBuyerConfirmation>
      >,
      {
        roomId: string;
        data: BodyType<SubmitContractDocumentBuyerConfirmationDto>;
      }
    > = (props) => {
      const { roomId, data } = props ?? {};

      return chatControllerSubmitContractDocumentBuyerConfirmation(
        roomId,
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ChatControllerSubmitContractDocumentBuyerConfirmationMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof chatControllerSubmitContractDocumentBuyerConfirmation>
    >
  >;
export type ChatControllerSubmitContractDocumentBuyerConfirmationMutationBody =
  BodyType<SubmitContractDocumentBuyerConfirmationDto>;
export type ChatControllerSubmitContractDocumentBuyerConfirmationMutationError =
  ErrorType<unknown>;

/**
 * @summary paperCode 135(수의계약체결제한여부확인서) 발주기관 최종 확인 (구매자 전용)
 */
export const useChatControllerSubmitContractDocumentBuyerConfirmation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof chatControllerSubmitContractDocumentBuyerConfirmation>
      >,
      TError,
      {
        roomId: string;
        data: BodyType<SubmitContractDocumentBuyerConfirmationDto>;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof chatControllerSubmitContractDocumentBuyerConfirmation>
  >,
  TError,
  {
    roomId: string;
    data: BodyType<SubmitContractDocumentBuyerConfirmationDto>;
  },
  TContext
> => {
  const mutationOptions =
    getChatControllerSubmitContractDocumentBuyerConfirmationMutationOptions(
      options,
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * c-market /files/{id} 는 인증·Accept 협상 제약, Supabase Storage 는 attachment 헤더로 브라우저에서 직접 열면 다운로드되거나 실패한다. 백엔드가 파일을 받아 magic-number 로 판별한 Content-Type 을 얹어 same-origin 으로 스트리밍한다.
 * @summary 계약 서류 인라인 프리뷰 프록시 (참가자 전용) — 실 Content-Type 판별 후 스트리밍
 */
export const chatControllerPreviewContractDocument = (
  roomId: string,
  paperCode: number,
  signal?: AbortSignal,
) => {
  return api<void>({
    url: `/chat/rooms/${roomId}/contract-documents/${paperCode}/preview`,
    method: "GET",
    signal,
  });
};

export const getChatControllerPreviewContractDocumentQueryKey = (
  roomId?: string,
  paperCode?: number,
) => {
  return [
    `/chat/rooms/${roomId}/contract-documents/${paperCode}/preview`,
  ] as const;
};

export const getChatControllerPreviewContractDocumentQueryOptions = <
  TData = Awaited<ReturnType<typeof chatControllerPreviewContractDocument>>,
  TError = ErrorType<unknown>,
>(
  roomId: string,
  paperCode: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof chatControllerPreviewContractDocument>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getChatControllerPreviewContractDocumentQueryKey(roomId, paperCode);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof chatControllerPreviewContractDocument>>
  > = ({ signal }) =>
    chatControllerPreviewContractDocument(roomId, paperCode, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(roomId && paperCode),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof chatControllerPreviewContractDocument>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ChatControllerPreviewContractDocumentQueryResult = NonNullable<
  Awaited<ReturnType<typeof chatControllerPreviewContractDocument>>
>;
export type ChatControllerPreviewContractDocumentQueryError =
  ErrorType<unknown>;

export function useChatControllerPreviewContractDocument<
  TData = Awaited<ReturnType<typeof chatControllerPreviewContractDocument>>,
  TError = ErrorType<unknown>,
>(
  roomId: string,
  paperCode: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof chatControllerPreviewContractDocument>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatControllerPreviewContractDocument>>,
          TError,
          Awaited<ReturnType<typeof chatControllerPreviewContractDocument>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useChatControllerPreviewContractDocument<
  TData = Awaited<ReturnType<typeof chatControllerPreviewContractDocument>>,
  TError = ErrorType<unknown>,
>(
  roomId: string,
  paperCode: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof chatControllerPreviewContractDocument>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatControllerPreviewContractDocument>>,
          TError,
          Awaited<ReturnType<typeof chatControllerPreviewContractDocument>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useChatControllerPreviewContractDocument<
  TData = Awaited<ReturnType<typeof chatControllerPreviewContractDocument>>,
  TError = ErrorType<unknown>,
>(
  roomId: string,
  paperCode: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof chatControllerPreviewContractDocument>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 계약 서류 인라인 프리뷰 프록시 (참가자 전용) — 실 Content-Type 판별 후 스트리밍
 */

export function useChatControllerPreviewContractDocument<
  TData = Awaited<ReturnType<typeof chatControllerPreviewContractDocument>>,
  TError = ErrorType<unknown>,
>(
  roomId: string,
  paperCode: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof chatControllerPreviewContractDocument>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getChatControllerPreviewContractDocumentQueryOptions(
    roomId,
    paperCode,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 프리뷰와 같은 경로로 파일을 받아 Content-Disposition: attachment 로 내려준다. 프론트가 원본 file_url 로 직접 앵커를 걸면 c-market /files/{id} 는 Bearer 토큰이 없어 401 로 죽는다 — 공급사가 올린 Supabase 서명 URL 만 살아남아 "일괄 다운로드에 일부만 담긴다" 는 증상이 된다.
 * @summary 계약 서류 다운로드 프록시 (참가자 전용)
 */
export const chatControllerDownloadContractDocument = (
  roomId: string,
  paperCode: number,
  signal?: AbortSignal,
) => {
  return api<void>({
    url: `/chat/rooms/${roomId}/contract-documents/${paperCode}/download`,
    method: "GET",
    signal,
  });
};

export const getChatControllerDownloadContractDocumentQueryKey = (
  roomId?: string,
  paperCode?: number,
) => {
  return [
    `/chat/rooms/${roomId}/contract-documents/${paperCode}/download`,
  ] as const;
};

export const getChatControllerDownloadContractDocumentQueryOptions = <
  TData = Awaited<ReturnType<typeof chatControllerDownloadContractDocument>>,
  TError = ErrorType<unknown>,
>(
  roomId: string,
  paperCode: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof chatControllerDownloadContractDocument>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getChatControllerDownloadContractDocumentQueryKey(roomId, paperCode);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof chatControllerDownloadContractDocument>>
  > = ({ signal }) =>
    chatControllerDownloadContractDocument(roomId, paperCode, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(roomId && paperCode),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof chatControllerDownloadContractDocument>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ChatControllerDownloadContractDocumentQueryResult = NonNullable<
  Awaited<ReturnType<typeof chatControllerDownloadContractDocument>>
>;
export type ChatControllerDownloadContractDocumentQueryError =
  ErrorType<unknown>;

export function useChatControllerDownloadContractDocument<
  TData = Awaited<ReturnType<typeof chatControllerDownloadContractDocument>>,
  TError = ErrorType<unknown>,
>(
  roomId: string,
  paperCode: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof chatControllerDownloadContractDocument>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatControllerDownloadContractDocument>>,
          TError,
          Awaited<ReturnType<typeof chatControllerDownloadContractDocument>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useChatControllerDownloadContractDocument<
  TData = Awaited<ReturnType<typeof chatControllerDownloadContractDocument>>,
  TError = ErrorType<unknown>,
>(
  roomId: string,
  paperCode: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof chatControllerDownloadContractDocument>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatControllerDownloadContractDocument>>,
          TError,
          Awaited<ReturnType<typeof chatControllerDownloadContractDocument>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useChatControllerDownloadContractDocument<
  TData = Awaited<ReturnType<typeof chatControllerDownloadContractDocument>>,
  TError = ErrorType<unknown>,
>(
  roomId: string,
  paperCode: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof chatControllerDownloadContractDocument>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 계약 서류 다운로드 프록시 (참가자 전용)
 */

export function useChatControllerDownloadContractDocument<
  TData = Awaited<ReturnType<typeof chatControllerDownloadContractDocument>>,
  TError = ErrorType<unknown>,
>(
  roomId: string,
  paperCode: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof chatControllerDownloadContractDocument>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getChatControllerDownloadContractDocumentQueryOptions(
    roomId,
    paperCode,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 계약 서류 파일 첨부 (공급사 전용, 직접 제출 서류)
 */
export const chatControllerUploadContractDocumentFile = (
  roomId: string,
  paperCode: number,
  chatControllerUploadContractDocumentFileBody: BodyType<ChatControllerUploadContractDocumentFileBody>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  if (chatControllerUploadContractDocumentFileBody.file !== undefined) {
    formData.append(`file`, chatControllerUploadContractDocumentFileBody.file);
  }

  return api<ChatControllerUploadContractDocumentFile200>({
    url: `/chat/rooms/${roomId}/contract-documents/${paperCode}/upload`,
    method: "POST",
    headers: { "Content-Type": "multipart/form-data" },
    data: formData,
    signal,
  });
};

export const getChatControllerUploadContractDocumentFileMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof chatControllerUploadContractDocumentFile>>,
    TError,
    {
      roomId: string;
      paperCode: number;
      data: BodyType<ChatControllerUploadContractDocumentFileBody>;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof chatControllerUploadContractDocumentFile>>,
  TError,
  {
    roomId: string;
    paperCode: number;
    data: BodyType<ChatControllerUploadContractDocumentFileBody>;
  },
  TContext
> => {
  const mutationKey = ["chatControllerUploadContractDocumentFile"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof chatControllerUploadContractDocumentFile>>,
    {
      roomId: string;
      paperCode: number;
      data: BodyType<ChatControllerUploadContractDocumentFileBody>;
    }
  > = (props) => {
    const { roomId, paperCode, data } = props ?? {};

    return chatControllerUploadContractDocumentFile(roomId, paperCode, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChatControllerUploadContractDocumentFileMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof chatControllerUploadContractDocumentFile>>
  >;
export type ChatControllerUploadContractDocumentFileMutationBody =
  BodyType<ChatControllerUploadContractDocumentFileBody>;
export type ChatControllerUploadContractDocumentFileMutationError =
  ErrorType<unknown>;

/**
 * @summary 계약 서류 파일 첨부 (공급사 전용, 직접 제출 서류)
 */
export const useChatControllerUploadContractDocumentFile = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof chatControllerUploadContractDocumentFile>>,
      TError,
      {
        roomId: string;
        paperCode: number;
        data: BodyType<ChatControllerUploadContractDocumentFileBody>;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof chatControllerUploadContractDocumentFile>>,
  TError,
  {
    roomId: string;
    paperCode: number;
    data: BodyType<ChatControllerUploadContractDocumentFileBody>;
  },
  TContext
> => {
  const mutationOptions =
    getChatControllerUploadContractDocumentFileMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 채팅방 읽음 처리
 */
export const chatControllerMarkAsRead = (
  roomId: string,
  markRoomAsReadDto: BodyType<MarkRoomAsReadDto>,
  signal?: AbortSignal,
) => {
  return api<void>({
    url: `/chat/rooms/${roomId}/read`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: markRoomAsReadDto,
    signal,
  });
};

export const getChatControllerMarkAsReadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof chatControllerMarkAsRead>>,
    TError,
    { roomId: string; data: BodyType<MarkRoomAsReadDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof chatControllerMarkAsRead>>,
  TError,
  { roomId: string; data: BodyType<MarkRoomAsReadDto> },
  TContext
> => {
  const mutationKey = ["chatControllerMarkAsRead"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof chatControllerMarkAsRead>>,
    { roomId: string; data: BodyType<MarkRoomAsReadDto> }
  > = (props) => {
    const { roomId, data } = props ?? {};

    return chatControllerMarkAsRead(roomId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChatControllerMarkAsReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof chatControllerMarkAsRead>>
>;
export type ChatControllerMarkAsReadMutationBody = BodyType<MarkRoomAsReadDto>;
export type ChatControllerMarkAsReadMutationError = ErrorType<unknown>;

/**
 * @summary 채팅방 읽음 처리
 */
export const useChatControllerMarkAsRead = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof chatControllerMarkAsRead>>,
      TError,
      { roomId: string; data: BodyType<MarkRoomAsReadDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof chatControllerMarkAsRead>>,
  TError,
  { roomId: string; data: BodyType<MarkRoomAsReadDto> },
  TContext
> => {
  const mutationOptions = getChatControllerMarkAsReadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 파일 업로드 및 메시지 전송
 */
export const chatControllerUploadFile = (
  roomId: string,
  chatControllerUploadFileBody: BodyType<ChatControllerUploadFileBody>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  if (chatControllerUploadFileBody.file !== undefined) {
    formData.append(`file`, chatControllerUploadFileBody.file);
  }

  return api<ChatControllerUploadFile200>({
    url: `/chat/rooms/${roomId}/upload`,
    method: "POST",
    headers: { "Content-Type": "multipart/form-data" },
    data: formData,
    signal,
  });
};

export const getChatControllerUploadFileMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof chatControllerUploadFile>>,
    TError,
    { roomId: string; data: BodyType<ChatControllerUploadFileBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof chatControllerUploadFile>>,
  TError,
  { roomId: string; data: BodyType<ChatControllerUploadFileBody> },
  TContext
> => {
  const mutationKey = ["chatControllerUploadFile"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof chatControllerUploadFile>>,
    { roomId: string; data: BodyType<ChatControllerUploadFileBody> }
  > = (props) => {
    const { roomId, data } = props ?? {};

    return chatControllerUploadFile(roomId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChatControllerUploadFileMutationResult = NonNullable<
  Awaited<ReturnType<typeof chatControllerUploadFile>>
>;
export type ChatControllerUploadFileMutationBody =
  BodyType<ChatControllerUploadFileBody>;
export type ChatControllerUploadFileMutationError = ErrorType<unknown>;

/**
 * @summary 파일 업로드 및 메시지 전송
 */
export const useChatControllerUploadFile = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof chatControllerUploadFile>>,
      TError,
      { roomId: string; data: BodyType<ChatControllerUploadFileBody> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof chatControllerUploadFile>>,
  TError,
  { roomId: string; data: BodyType<ChatControllerUploadFileBody> },
  TContext
> => {
  const mutationOptions = getChatControllerUploadFileMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 견적 수정 요청 전송
 */
export const chatControllerSubmitQuoteRevision = (
  roomId: string,
  createQuoteResponseVersionDto: BodyType<CreateQuoteResponseVersionDto>,
  signal?: AbortSignal,
) => {
  return api<ChatControllerSubmitQuoteRevision200>({
    url: `/chat/rooms/${roomId}/quote-revision`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createQuoteResponseVersionDto,
    signal,
  });
};

export const getChatControllerSubmitQuoteRevisionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof chatControllerSubmitQuoteRevision>>,
    TError,
    { roomId: string; data: BodyType<CreateQuoteResponseVersionDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof chatControllerSubmitQuoteRevision>>,
  TError,
  { roomId: string; data: BodyType<CreateQuoteResponseVersionDto> },
  TContext
> => {
  const mutationKey = ["chatControllerSubmitQuoteRevision"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof chatControllerSubmitQuoteRevision>>,
    { roomId: string; data: BodyType<CreateQuoteResponseVersionDto> }
  > = (props) => {
    const { roomId, data } = props ?? {};

    return chatControllerSubmitQuoteRevision(roomId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChatControllerSubmitQuoteRevisionMutationResult = NonNullable<
  Awaited<ReturnType<typeof chatControllerSubmitQuoteRevision>>
>;
export type ChatControllerSubmitQuoteRevisionMutationBody =
  BodyType<CreateQuoteResponseVersionDto>;
export type ChatControllerSubmitQuoteRevisionMutationError = ErrorType<unknown>;

/**
 * @summary 견적 수정 요청 전송
 */
export const useChatControllerSubmitQuoteRevision = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof chatControllerSubmitQuoteRevision>>,
      TError,
      { roomId: string; data: BodyType<CreateQuoteResponseVersionDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof chatControllerSubmitQuoteRevision>>,
  TError,
  { roomId: string; data: BodyType<CreateQuoteResponseVersionDto> },
  TContext
> => {
  const mutationOptions =
    getChatControllerSubmitQuoteRevisionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
